export default "__VITE_ASSET__DMOGn3Wl__"